module.exports = __webpack_public_path__ + "img/drone_05_H.190583b8.webp";